import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'semantic-ui-css/semantic.min.css';
// Firebase + Mixpanel Analytics
import { analyticsService } from './services/analytics.service';
// PWA Service Worker (GRO-31)
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Initialize analytics when app loads
analyticsService.init();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA support (GRO-31)
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // New version available - could show a toast notification
  },
  onSuccess: () => {
    // App ready for offline use
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
